import React from 'react';

const EditUserPreference = () => {

    return <div>preference</div>;
};

export default EditUserPreference;